import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SovereignHomePage from "./pages/SovereignHomePage";
import LandingPage from "./pages/LandingPage";
import AcceptPage from "./pages/AcceptPage";
import AccessPage from "./pages/AccessPage";
import PartnersPage from "./pages/PartnersPage";
import AdminDashboard from "./pages/AdminDashboard";
import InvestorsRedirect from "./pages/InvestorsRedirect";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SovereignHomePage />} />
        <Route path="/the-room" element={<LandingPage />} />
        <Route path="/investors" element={<InvestorsRedirect />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/access/:token" element={<AccessPage />} />
        <Route path="/access/:token/success" element={<AccessPage />} />
        <Route path="/accept/:token" element={<AcceptPage />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
